import React from 'react';
import { PaginationTable, Tag } from '@ver-uds/react';
import { Accordion } from '@ver-uds/uswds-react';
import { Account, CompanyInfo } from 'eve-account-client';
import type { Column } from 'react-table';

const DEFAULT_PAGE_SIZE_OPTIONS = [10, 20, 50];

type TableData = {
  companyInfo: CompanyInfo;
  id?: string;
};

type SelectedCompanyLocationsAccordionProps = {
  selectedAccounts: Array<Account>;
};

const tableColumns: Column<TableData>[] = [
  {
    Header: 'Company Name',
    accessor: (row) => row.companyInfo.companyName,
  },
  {
    Header: 'Company Number',
    accessor: (row) => row.id,
    width: 60,
  },
];

const SelectedCompanyLocationsAccordion = ({
  selectedAccounts,
}: SelectedCompanyLocationsAccordionProps): JSX.Element => {
  return (
    <Accordion bordered>
      <Accordion.Heading controls="company-locations-accordion">
        Selected {selectedAccounts.length === 1 ? 'Company' : 'Companies'} to be Terminated{' '}
        <Tag>{selectedAccounts?.length}</Tag>
      </Accordion.Heading>
      <Accordion.Content id="company-locations-accordion">
        <PaginationTable
          id="selected-company-locations-for-termination"
          columns={tableColumns}
          data={selectedAccounts}
          variant="default"
          initialState={{
            pageIndex: 0,
            pageSize: DEFAULT_PAGE_SIZE_OPTIONS[0],
          }}
        />
      </Accordion.Content>
    </Accordion>
  );
};

export default SelectedCompanyLocationsAccordion;
